import React, { useState } from 'react';
import Sidebar from './Sidebar';
import AppHeader from './AppHeader';

export default function Layout({ children }) {
    const [collapsed, setCollapsed] = useState(false);

    return (
        <div className="app-layout">
            <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(c => !c)} />
            <AppHeader sidebarCollapsed={collapsed} />
            <main className={`main-content${collapsed ? ' sidebar-collapsed' : ''}`}>
                {children}
            </main>
        </div>
    );
}
